export const fileToBase64 = async (file: File) =>
  await new Promise((resolve, reject) => {
    const reader = new FileReader();

    const cleanup = () => {
      reader.removeEventListener("load", onLoad);
      reader.removeEventListener("error", onError);
      reader.abort();
    };

    const onLoad = () => {
      cleanup();
      resolve(reader.result);
    };

    const onError = () => {
      cleanup();
      reject(reader.error);
    };

    reader.addEventListener("load", onLoad);
    reader.addEventListener("error", onError);

    reader.readAsDataURL(file);
  });
